export const PAYMENT_STORES = [
  { name: 'bbva', image: '@/assets/images/stores/bbva.png' },
  { name: 'chedraui', image: '@/assets/images/stores/chedraui.png' },
  { name: 'farmacias_ahorro', image: '@/assets/images/stores/farmacias_ahorro.png' },
  { name: 'hsbc', image: '@/assets/images/stores/hsbc.png' },
  { name: 'oxxo', image: '@/assets/images/stores/oxxo.png' },
  { name: 'walmart', image: '@/assets/images/stores/walmart.png' }
];

export const PAYMENT_STORES_URL = 'https://dish.com.mx/soporte-y-servicio/lugares-de-pago-dish';
